import {
    APPROVE_ITEM_START,
    APPROVE_ITEM_ERROR,
    APPROVE_DISCOUNT_START,
    APPROVE_DISCOUNT_ERROR,
    CREATE_PAYLINK_START,
    CREATE_PAYLINK_ERROR,
    DELAY_PAYMENT_START,
    DELAY_PAYMENT_ERROR,
    SUGGEST_DISCOUNT_START,
    SUGGEST_DISCOUNT_ERROR,
    NEW_PAYMENT_DATA_RECEIVED,
} from './paymentActionTypes';

const initialState = {
    error: false,
    loading: false,
    data: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case NEW_PAYMENT_DATA_RECEIVED:
            return {
                data: {
                    ...state.data,
                    ...action.payload.data,
                },
                loading: false,
                error: false,
            };
        case APPROVE_ITEM_START:
        case CREATE_PAYLINK_START:
        case APPROVE_DISCOUNT_START:
        case DELAY_PAYMENT_START:
        case SUGGEST_DISCOUNT_START:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case APPROVE_ITEM_ERROR:
        case APPROVE_DISCOUNT_ERROR:
        case CREATE_PAYLINK_ERROR:
        case DELAY_PAYMENT_ERROR:
        case SUGGEST_DISCOUNT_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/paymentReducer.js